import { useMyDataContext } from "@/hooks/context/useMyDataContext";
import { PropsWithChildren, ReactNode } from "react";

const CancelPageWrapper = ({ fallback, children }: { fallback: ReactNode } & PropsWithChildren) => {
  const { isError } = useMyDataContext();

  return isError ? fallback : children;
};

export default CancelPageWrapper;
